/**
 * Nuxt route middleware to restrict access to certain routes based on the user's country or IP address.
 *
 * - Checks if the current route is protected.
 * - Skips checks for bots and non-protected routes.
 * - Uses local storage to cache geolocation and IP information.
 * - Fetches geolocation data from a Netlify serverless function if not cached.
 * - Compares the user's country code and IP address against blocklists and whitelists from runtime config.
 * - Redirects to "/unavailable" if the user is from a blocked country or IP and not whitelisted.
 *
 * @param to - The target route object.
 * @param from - The current route object.
 * @returns {Promise<boolean|void>} Returns `true` to allow navigation, or redirects to "/unavailable" for blocked users.
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.client) {
    const protectedRoutes = ["/trial", "/register", "/developer-trial", "/referrals", "/get-a-demo", "/talk-to-an-expert", "/become-a-partner", "/partners/jobadder", "/partners/ecommerce-equation-customers", "/partners/ecommerce-equation-ee"];
    const protectRoutes = protectedRoutes.includes(from.path);

    if (!protectRoutes) return true;

    const config = useRuntimeConfig().public;
    const { setItem, getItem } = useLocalStorage();

    const userAgent = typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "";
    const isBot = /bot|crawl|spider|slurp|bingpreview|mediapartners-google|facebookexternalhit|adsbot|google web preview|phantomjs|headless|duckduckbot|baiduspider|yandex|sogou|exabot|facebot|ia_archiver/.test(userAgent);

    if (isBot) return true;

    const kudoGeo = getItem("kudogeo");

    const blockListCountry = (config.FILTER_COUNTRY || "").split(",");
    const blockListIP = (config.FILTER_IP || "").split(",");
    const whiteListIP = (config.FILTER_IP_WHITE || "").split(",");
    const blackListed = null;
    if (!kudoGeo) {
      let result;
      try {
        const response = await fetch(`/.netlify/functions/info`);

        result = await response.json();
      } catch (e) {
        console.warn(e);
      }

      if (result) {
        setItem("kudogeo", {
          data: result,
          country_code: result.country_code2,
          ip: result.ip,
        });

        if (whiteListIP.includes(result.ip)) {
          // return false;
        }

        if (blockListCountry.includes(result.country_code2) || blockListIP.includes(result.ip)) {
          if (protectRoutes) return navigateTo("/unavailable");
        }
      }

      if (blackListed) {
        if (protectRoutes) return navigateTo("/unavailable");
      }
    } else {
      if (whiteListIP.includes(kudoGeo.ip)) {
        // return false;
      }

      if (blockListCountry.includes(kudoGeo.country_code) || blockListIP.includes(kudoGeo.ip)) {
        if (protectRoutes) return navigateTo("/unavailable");
      }
    }

    return true;
  }
});
